import React, { useState } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { images } from '../constants'
import { TabItem } from '../components'
import { IconTabs } from '../assets/icons'
import { tabItems } from '../config'

const SectionWrapper = styled.section`
  overflow: hidden;
  width: 100%;
  background-color: var(--black-dark);
  margin: 140px 0 0 0;
  padding: 80px 0;
  @media screen and (max-width: 1023px) {
    margin: 120px 0 0 0;
  }
  @media screen and (max-width: 800px) {
    margin: 100px 0 0 0;
  }
`
const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  width: 86%;
  max-width: var(--max-inner);
  margin: 0 auto;
  color: var(--text);
  h2.service-subtitle {
    text-align: center;
    margin-bottom: 15px;
  }
  p.service-description {
    text-align: center;
    color: var(--text);
    font-size: var(--fz-lg);
  }
`
const SectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 86%;
  max-width: var(--max-width);
  margin: 0 auto;
  color: var(--text);
  .tabitem-1,
  .tabitem-2,
  .tabitem-3,
  .tabitem-4 {
    width: 100%;
  }
  @media screen and (max-width: 1023px) {
    flex-direction: column;
    .tabitem-1,
    .tabitem-2,
    .tabitem-3,
    .tabitem-4 {
      width: 50%;
    }
  }
  @media screen and (max-width: 800px) {
    width: calc(100% - 50px);
    margin: 0 25px;
    .tabitem-1,
    .tabitem-2,
    .tabitem-3,
    .tabitem-4 {
      width: 100%;
    }
  }
`
const LeftColumn = styled.div`
  width: 300px;
  @media screen and (max-width: 1023px) {
    width: 100%;
  }
`
const InnerTabs = styled.aside`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 135px 0 0;
  @media screen and (max-width: 1023px) {
    flex-direction: row;
    flex-wrap: wrap;
    padding: 70px 0 30px;
  }
  @media screen and (max-width: 800px) {
    padding: 50px 0 0;
  }
`
const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: calc(100% - 300px);
  heigth: 100%;
  padding: 60px 0 0 60px;
  @media screen and (max-width: 1023px) {
    width: 100%;
    padding: 30px 0 0 0;
  }
`
const InnerHeader = styled.div`
  display: block;
  position: relative;
  margin-bottom: 30px;
  padding-left: 37px;
  &.shopify-support path {
    fill: var(--service-support);
  }
  &.shopify-design path {
    fill: var(--service-design);
  }
  &.shopify-marketing path {
    fill: var(--service-marketing);
  }
  &.shopify-development path {
    fill: var(--service-development);
  }
  h3 {
    position: absolute;
    left: 97px;
    top: 8px;
    color: var(--title);
    font-family: var(--font-sans);
    font-size: 22px;
    font-weight: 600;
    line-height: 1.25;
  }
  @media screen and (max-width: 800px) {
    display: none;
  }
`
const InnerServices = styled.div`
  width: 100%;
  padding: 32px 36px 32px 36px;
  border-radius: 8px;
  border: 1px solid var(--black-dark);
  box-shadow: 0 0 0 1px rgb(0 0 0 / 1%), 0 25px 25px rgb(0 0 0 / 3%), 0 15px 15px rgb(0 0 0 / 6%), 0 10px 8px rgb(0 0 0 / 5%), 0 4px 4px rgb(0 0 0 / 4%), 0 2px 2px rgb(0 0 0 / 3%);
  background-color: var(--black-light);
  p {
    color: var(--white);
    margin: 0 0 28px;
  }
  .shopify-icon {
    width: 240px;
  }
`
const InnerSubtitle = styled.div`
  display: flex;
  width: 100%;
  padding: 50px 0 20px 40px;
  @media screen and (max-width: 800px) {
  }
`
const InnerExamples = styled.div`
  display: flex;
  flex-direction: column;
`
const ExampleOne = styled.div`
  width: calc(100% - 20px);
  padding: 24px 28px 24px 28px;
  margin: 0 0 0 10px;
  border-radius: 8px;
  background-color: var(--grey-hover);
  p {
    font-size: var(--fz-md);
  }
`
const ExampleTwo = styled.div`
  width: calc(100% - 20px);
  padding: 24px 28px 24px 28px;
  margin: 15px 0 0 10px;
  border-radius: 8px;
  background-color: var(--black-light);
  p {
    font-size: var(--fz-md);
  }
  @media screen and (max-width: 1023px) {
    width: calc(100% - 20px);
    margin: 15px 0 0 10px;
  }
`
const LinkList = styled.ul`
  display: grid;
  grid-template-columns: repeat(3, minmax(140px, 230px));
  gap: 0px 5px;
  padding: 40px 0 0 35px;
  list-style: none;
  &.shopify-design li::before {
    color: var(--service-design);
  }
  &.shopify-design li a:hover {
    color: var(--service-design);
  }
  &.shopify-development li::before {
    color: var(--service-development);
  }
  &.shopify-development li a:hover {
    color: var(--service-development);
  }
  &.shopify-marketing li::before {
    color: var(--service-marketing);
  }
  &.shopify-marketing li a:hover {
    color: var(--service-marketing);
  }
  &.shopify-support li::before {
    color: var(--service-support);
  }
  &.shopify-support li a:hover {
    color: var(--service-support);
  }
  li {
    position: relative;
    margin-bottom: 10px;
    padding-left: 15px;
    font-size: var(--fz-sm);
    transition: var(--transition);
    a {
      color: var(--grey-medium);
    }
    a:hover {
      color: var(--service-design);
    }
  }
  li::before {
    content: '▹';
    position: absolute;
    left: 0px;
    color: var(--service-design);
    font-family: var(--font-sans);
    font-size: var(--fz-xs);
    font-weight: 500;
    line-height: 20px;
  }
  @media screen and (max-width: 1200px) {
    padding: 40px 0 0 37px;
    grid-template-columns: repeat(2, minmax(140px, 230px));
  }
  @media screen and (max-width: 1023px) {
    grid-template-columns: repeat(3, minmax(140px, 230px));
  }
  @media screen and (max-width: 800px) {
    grid-template-columns: repeat(2, minmax(140px, 230px));
  }
  @media screen and (max-width: 600px) {
    padding: 40px 0 0 8px;
  }
`

const HomeService = () => {
  const [active, setActive] = useState(1)

  const urlServiceDesign1 = <Link to={'/shopify-services/converting-collection-banners'}>Converting Collection Banners</Link>
  const urlServiceDesign2 = <Link to={'/shopify-services/converting-newsletter-design'}>Converting Newsletter Design</Link>
  const urlServiceDesign3 = <Link to={'/shopify-services/converting-hero-images'}>Converting Hero Images</Link>
  const urlServiceDesign4 = <Link to={'/shopify-services/newsletter-popups-design'}>Newsletter Popups Design</Link>
  const urlServiceDesign5 = <Link to={'/shopify-services/email-header-design'}>Email Header Design</Link>
  const urlServiceDesign6 = <Link to={'/shopify-services/custom-icon-design'}>Custom Icon Design</Link>
  const urlServiceDesign7 = <Link to={'/shopify-services/social-media-ads-that-convert'}>Social Media Ads That Convert</Link>
  const urlServiceDesign8 = <Link to={'/shopify-services/banner-ads-that-convert'}>Banner Ads That Convert</Link>
  const urlServiceDesign9 = <Link to={'/shopify-services/social-media-cover-photos'}>Social Media Cover Photos</Link>
  const urlServiceDevelopment1 = <Link to={'/shopify-services/shopify-custom-development'}>Custom Development</Link>
  const urlServiceDevelopment2 = <Link to={'/shopify-services/shopify-advanced-customization'}>Advanced Customization</Link>
  const urlServiceSupport1 = <Link to={'/shopify-services/shopify-theme-tweaks-changes'}> Theme Tweaks & Changes</Link>
  const urlServiceMarketing1 = <Link to={'/shopify-services/shopify-theme-tweaks-changes'}> Theme Tweaks & Changes</Link>

  return (
    <SectionWrapper>
      <SectionHeader>
        <h2 className="service-subtitle">Services I can provide</h2>
        <p className="service-description">I am passionate about helping entrepreneurs create successful and profitable online stores with Shopify. My services range from setting up your store to customizing the look and optimizing it for search engine optimization.</p>
      </SectionHeader>
      <SectionContainer>
        <LeftColumn>
          <InnerTabs>
            {tabItems.map(({ id, icon, style, title }) => (
              <TabItem key={title} icon={icon} style={style} title={title} onItemClicked={() => setActive(id)} isActive={active === id} />
            ))}
          </InnerTabs>
        </LeftColumn>
        <RightColumn>
          {tabItems.map(({ id, icon, title2 }) => {
            if (active === id) {
              return (
                <InnerHeader className={icon}>
                  <IconTabs name={icon} />
                  <h3>{title2}</h3>
                </InnerHeader>
              )
            }
          })}
          {tabItems.map(({ id, content }) => {
            if (active === id) {
              return (
                <InnerServices>
                  <p>{content}</p>
                  <img src={images.service_shopify} alt="Shopify" className="shopify-icon" />
                </InnerServices>
              )
            }
          })}
          <InnerSubtitle>
            <h5>Examples</h5>
          </InnerSubtitle>
          <InnerExamples>
            <ExampleOne>
              <p>
                {tabItems.map(({ id, example1 }) => {
                  return active === id ? example1 : ''
                })}
              </p>
            </ExampleOne>
            <ExampleTwo>
              <p>
                {tabItems.map(({ id, example2 }) => {
                  return active === id ? example2 : ''
                })}
              </p>
            </ExampleTwo>
          </InnerExamples>
          {active && active === 1 ? (
            <LinkList className="shopify-design">
              <li>{urlServiceDesign1}</li>
              <li>{urlServiceDesign2}</li>
              <li>{urlServiceDesign3}</li>
              <li>{urlServiceDesign4}</li>
              <li>{urlServiceDesign5}</li>
              <li>{urlServiceDesign6}</li>
              <li>{urlServiceDesign7}</li>
              <li>{urlServiceDesign8}</li>
              <li>{urlServiceDesign9}</li>
            </LinkList>
          ) : (
            ''
          )}
          {active && active === 2 ? (
            <LinkList className="shopify-development">
              <li>{urlServiceDevelopment1}</li>
              <li>{urlServiceDevelopment2}</li>
            </LinkList>
          ) : (
            ''
          )}
          {active && active === 3 ? (
            <LinkList className="shopify-marketing">
              <li>{urlServiceMarketing1}</li>
            </LinkList>
          ) : (
            ''
          )}
          {active && active === 4 ? (
            <LinkList className="shopify-support">
              <li>{urlServiceSupport1}</li>
            </LinkList>
          ) : (
            ''
          )}
        </RightColumn>
      </SectionContainer>
    </SectionWrapper>
  )
}

export default HomeService
